<template>
  <div class="field suggestion-input">
    <div :class="['control', { 'is-loading': isLoading }]">
      <input :placeholder="field.placeholder" autocomplete="off"
             class="suggestion-input__field" type="text" v-model="lookupString" @focus="canShowBox" @blur="hideBox" />
    </div>
    <div class="suggestion-input__box" v-if="Object.keys(results).length && showBox">
      <div class="suggestion-input__row" v-for="(result, key) in results" v-bind="result.props" @click="selected(key)">
        {{ result.label }}
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'SuggestionInput',
    props: {
      field: {
        type: Object,
        default () {
          return {
            placeholder: ''
          }
        }
      },
      results: {
        type: Object
      }
    },
    data () {
      return {
        isLoading: false,
        lookupString: '',
        showBox: true
      }
    },
    methods: {
      selected (key) {
        this.lookupString = ''
        this.$emit('suggestion-selected', key)
      },
      canShowBox () {
        this.showBox = true
      },
      hideBox () {
        setTimeout(() => {
          this.showBox = false
        }, 200)
      }
    },
    watch: {
      results () {
        this.isLoading = false
      },
      lookupString () {
        this.isLoading = true
        this.$emit('suggestion-input', this.lookupString)
      }
    }
  }
</script>

<style scoped>
  .control.is-loading::after {
    top: 0.3em
  }

  .suggestion-input {
    width: 194px;
    position: relative;
  }

  .suggestion-input__field {
    opacity: 0.5;
    font-size: 11px;
    color: #58595b;
    padding-left: 5px;
    border: none;
    width: 100%;
    padding-bottom: 2px;
  }

  .suggestion-input__field:focus {
    border-bottom: 1px solid rgba(88, 89, 91, 0.32);
  }

  .suggestion-input__box {
    position: absolute;
    border: 1px solid rgba(88, 89, 91, 0.32);
    height: 166px;
    z-index: 1;
    background-color: #fff;
    width: 100%;
    top: 23px;
    overflow-y: auto;
  }

  .suggestion-input__row {
    border-bottom: 1px solid rgba(40, 44, 48, 0.1);
    font-size: 11px;
    color: #58595b;
    padding: 12px 15px;
    cursor: pointer;
  }

  .suggestion-input__row:hover {
    color: #30aae1;
  }

  ::-webkit-scrollbar {
    width: 6px;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: #bcbec0;
    border-radius: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/SuggestionInput.vue